<template>
<div class="chapter">
<div class="inner_page">
<p class="author"><a id="page_iii">JENNIE MALBOEUF</a></p><a id="page_iii">
<p class="title">God had a body</p>
<p class="title1"><i>Poems</i></p>
<p class="pubt">Indiana University Press</p>
<p class="pub">Indiana Review</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Title.vue?20eedc69